import { FunctionComponent, useEffect, useMemo, useState } from 'react';
import '../../../css/PublicWhatWeDoPage.css';
import GenericIcons from '../../../components/generics/GenericIcons';
import { useNavigate } from 'react-router-dom';
import { btnKey } from '../PublicWhatWeDoPage';
import {
  Component02,
  Component03,
  Component04,
  Component05,
  Component06,
  Component07
} from '../WhatWeDoPages/index';

const Component01: FunctionComponent = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 700);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const whatWeDoBtns: Array<{
    key: btnKey;
    name: string;
    icon: string;
    component: JSX.Element;
  }> = useMemo(
    () => [
      {
        key: btnKey.mapa,
        name: 'Mapa Interactivo de Redes',
        icon: 'mapMarkedSolidLargeIcon',
        component: <Component02 />
      },
      {
        key: btnKey.gestion,
        name: 'Gestión de Datos de Redes',
        icon: 'databaseSolidLargeIcon',
        component: <Component03 />
      },
      {
        key: btnKey.capacidad,
        name: 'Capacidad de Alojamiento de Redes',
        icon: 'LightbulbFilamentIcon',
        component: <Component04 />
      },
      {
        key: btnKey.evaluacion,
        name: 'Evaluación de Conexión de Proyectos',
        icon: 'clipboardListSolidLargeIcon',
        component: <Component05 />
      },
      {
        key: btnKey.puntos,
        name: 'Puntos Robustos de Red',
        icon: 'LightningIcon',
        component: <Component06 />
      },
      {
        key: btnKey.estadisticas,
        name: 'Estadísticas del Sector',
        icon: 'chartBarSolidLargeIcon',
        component: <Component07 />
      }
    ],
    []
  );

  return (
    <div className='public-what-we-do-page-component-one-container vdr-wwd-doc'>
      <div className='vdr-section-head vdr-wwd-section-head'>
        <h2 className='public-what-we-do-page-title'>¿Qué Hacemos?</h2>
        <small>Plataforma</small>
      </div>
      <div className='public-what-we-do-page-component-one-content'>
        <p className='public-what-we-do-page-text vdr-wwd-lead'>
          VisiónDERRED es una plataforma integral que pone a disposición de los usuarios
          herramientas avanzadas para gestionar y analizar redes eléctricas de distribución. A
          través de su interfaz intuitiva, ofrecemos soluciones para mejorar la visibilidad de las
          redes eléctricas, optimizar el uso de datos de las empresas, evaluar la capacidad de
          alojamiento de recursos energéticos distribuidos y más. A continuación, te presentamos las
          herramientas que podrás encontrar en nuestra plataforma:
        </p>
        <div className='public-component-one-what-we-do-grid public-component-one-what-we-do-btns-container'>
          {whatWeDoBtns.map((btn, idx) => (
            <div key={`public-component-one-what-we-do-what-we-do-btn-key-${idx}`}>
              <button
                className='interactive-button public-component-one-what-we-do-interactive-button vdr-wwd-tool'
                data-tool={btn.key}
                onClick={() => navigate(`/public/que-hacemos?option=${btn.key}`)}>
                {/* Imagen de la red por herramienta: se asigna en CSS según data-tool. */}
                <span className='vdr-wwd-tool-media' aria-hidden='true' />
                <span className='vdr-wwd-tool-body'>
                  <span className='vdr-wwd-tool-top' aria-hidden='true'>
                    <span className='vdr-icon-tile vdr-wwd-tool-icon'>
                      <GenericIcons
                        icon={btn.icon}
                        imageStyle={{ height: isMobile ? '8vw' : '2vw' }}
                      />
                    </span>
                    <span className='vdr-wwd-tool-arrow'>→</span>
                  </span>
                  <span className='vdr-wwd-tool-name'>{btn.name}</span>
                </span>
              </button>
            </div>
          ))}
        </div>
        <p className='public-what-we-do-page-text vdr-wwd-closing'>
          <span className='vdr-wwd-closing-lead'>
            ¡Descubre cómo VisiónDERRED puede transformar la gestión y planificación de tu red
            eléctrica!
          </span>{' '}
          <span className='vdr-wwd-closing-sub'>
            ¡Apóyate en nuestras herramientas para facilitar tus evaluaciones preliminares de
            factibilidad técnica de proyectos de generación distribuida!
          </span>
        </p>
      </div>
    </div>
  );
};

export default Component01;
